// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-tab[data-v-d6b7ff6c]{border-right:1px solid #e5e5e5}.active-tab[data-v-d6b7ff6c]{background-color:#fff}.tabs[data-v-d6b7ff6c]{border-color:#707070;border-radius:7px;box-shadow:0px 3px 6px #00000029}.tabs[data-v-d6b7ff6c] ::first-child{border-top-left-radius:7px;border-bottom-left-radius:7px}.tabs[data-v-d6b7ff6c] ::last-child{border-top-right-radius:7px;border-bottom-right-radius:7px}.v-tab--active[data-v-d6b7ff6c]{border:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
